import { IBookDetailPublic } from 'src/types/DTO/public/IBookDetailPublic';
import { IBookPublic } from 'src/types/DTO/public/IBookPublic';
import { toFieldBriefs } from './Field.mapper';

export const toBookPublics = (data: any): IBookPublic[] =>
  data?.map((item: any): IBookPublic => toBookPublic(item));

export const toBookPublic = (item: any): IBookPublic => ({
  id: item?.id,
  name: item?.bookName,
  slug: item?.slug,
  description: item?.bookDes,
  otherName: item?.otherName,
  author: item?.author,
  pages: item?.pages,
  yearPublication: item?.yearPublication,
  rePublic: item?.rePublic,
  price: item?.price,
  photoURL: item?.photoURL,
  createdAt: item?.createdAt,
  categoryName: item?.categoryName,
  publisherName: item?.pubName,
  language: item?.lanName,
  fieldList: item?.fieldList,
  loanFee: item?.loanFee,
  penaltyApplied: item?.penaltyApplied,
  attachFiles: item?.attachFiles,
  manageInfor: item?.detailBooks,
  reviewsList: item?.reviews
});

export const toBookDetailPublics = (data: any): IBookDetailPublic[] =>
  data?.map(
    (book: any): IBookDetailPublic => ({
      id: book?.id,
      code: book?.bookCode,
      name: book?.bookName,
      slug: book?.slug,
      description: book?.bookDes,
      otherName: book?.otherName,
      author: book?.author,
      pages: book?.pages,
      yearPublication: book?.yearPublication,
      rePublic: book?.rePublic,
      price: book?.price,
      photoURL: book?.photoURL,
      createdAt: book?.createdAt,
      categoryName: book?.categoryName,
      categoryId: book?.categoryId,
      publisherName: book?.pubName,
      publisherId: book?.pubId,
      languageName: book?.lanName,
      languageId: book?.lanId,
      fieldList: toFieldBriefs(book?.fieldList),
      penaltyApplied: book?.penaltyApplied,
      loanFee: book?.loanFee,
      status: book?.status,
      statusId: book?.statusId,
      positionName: book?.positionName,
      positionId: book?.positionId,
      attachFiles: book?.attachFiles,
      isReady: book?.isReady,
    })
  );
